import axios from 'axios';
import qs from 'qs';
import { Loading , Message } from 'element-ui';
import { getStore } from '@/utils/';

let loaddingIndex;

// 添加响应拦截器
axios.interceptors.response.use(res => {
    if(loaddingIndex){
        loaddingIndex.close();
    }
    return Promise.resolve(res);
},err=>{
    if(loaddingIndex){
        loaddingIndex.close();
    }
    if (err && err.response) {
        switch (err.response.status) {
            case 400: err.message = '请求错误(400)' ; break;
            case 401: err.message = '未授权，请重新登录(401)'; break;
            case 403: err.message = '拒绝访问(403)'; break;
            case 404: err.message = '请求出错(404)'; break;
            case 408: err.message = '请求超时(408)'; break;
            case 500: err.message = '服务器错误(500)'; break;
            case 501: err.message = '服务未实现(501)'; break;
            case 502: err.message = '网络错误(502)'; break;
            case 503: err.message = '服务不可用(503)'; break;
            case 504: err.message = '网络超时(504)'; break;
            case 505: err.message = 'HTTP版本不受支持(505)'; break;
            default: err.message = `连接出错(${err.response.status})!`;
        }
    }else{
        err.message = '连接服务器失败!';
    }
    Message({
        message:err.message,
        type:'error'
    });
	// setTimeout(function(){
	// 	window.location.href = '/'
	// },3000)
    return Promise.reject(err);
});

function apiAxios (method, url, params) {
	let auth = getStore('member')&&getStore('member').token ? 'Bearer ' + getStore('member').token : '';
	// 在发送请求之前做些什么
	loaddingIndex = Loading.service({
		lock: true,
		text: '加载中',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0.7)'
	});
    return new Promise((resolve,reject)=>{
        axios({
            method: method,
            headers:{
				"Content-Type":'application/x-www-form-urlencoded; charset=UTF-8',
				'authorization':auth
			},
            url: url,
            data: method === 'post'? qs.stringify(params) : null,
            params: method === 'get'? params : null,
            // baseURL:'/',
        }).then(function (res) {
            resolve(res);
        }).catch(function (err) {
            reject(err);
        });
    });
}

// 返回在vue模板中的调用接口
export default {
    get:  async(url, params) => {
        try {
            const res = await apiAxios('get',url, params);
            if(res && res.status === 200){
                return Promise.resolve(res.data);
            }
        } catch(err) {
            return Promise.reject(err);
        }
    },
    post:  async(url, params) => {
        try {
            const res = await apiAxios('post',url, params);
            if(res && res.status === 200){
                return Promise.resolve(res.data);
            }
        } catch(err) {
            return Promise.reject(err);
        }
    }
}